import { useState, useMemo } from 'react';

import { ChevronRight } from 'lucide-react';

import CouponListPopup from './CouponListPopup';

export default function ProductCoupon({ data }) {
  const couponList = useMemo(() => {
    return data.productCouponList || [];
  }, [data]);

  const productCoupon = useMemo(() => {
    return couponList
      .filter((item) => item.couponType === 'product')
      .sort((a, b) => {
        return a.couponDiscount - a.couponAmount - (b.couponDiscount - b.couponAmount);
      });
  }, [couponList]);

  const discountCoupon = useMemo(() => {
    return couponList
      .filter((item) => item.couponType === 'discount')
      .sort((a, b) => a.couponDiscount - b.couponDiscount);
  }, [couponList]);

  const freightCoupon = useMemo(() => {
    return couponList.filter((item) => item.couponType === 'freight');
  }, [couponList]);

  const couponData = useMemo(() => {
    let arr = [];
    const num = [productCoupon.length, discountCoupon.length, freightCoupon.length];
    const listArr = [productCoupon, discountCoupon, freightCoupon];

    // 每种券类显示一个
    if (!num.includes(0)) {
      arr = [productCoupon[0], discountCoupon[0], freightCoupon[0]];
    } else if (listArr.filter((item) => item.length > 0).length === 1) {
      arr = listArr.filter((item) => item.length > 0)[0].slice(0, 2);
    } else if (listArr.filter((item) => item.length > 0).length === 2) {
      arr = [listArr.filter((item) => item.length > 0)[0][0], listArr.filter((item) => item.length > 0)[1][0]];
    }

    // 判断最多显示2个券类
    arr = arr.length >= 3 ? arr.slice(0, 2) : arr;

    return arr;
  }, [productCoupon, discountCoupon, freightCoupon]);

  const CouponList = () => {
    if (couponList.length > 0 || data.hasPlusCoupon) {
      return (
        <>
          {/* plus专享券 */}
          {data.hasPlusCoupon && (
            <div className="mr-[6px] min-w-[88px] h-[18px] flex text-center leading-[16px] rounded-[4px] border border-solid border-[#e84c4c]">
              <span className="w-[36px] h-[18px] text-white text-[12px] rounded-[4px_0px_8px_4px] bg-[#e84c4c]">
                plus
              </span>
              <span className="text-[#e84c4c] whitespace-nowrap mx-[5px]">领券</span>
            </div>
          )}
          {couponData.map((item, index) =>
            item.isFreeExpress ? (
              // 包邮券
              <div
                className="mr-[6px] w-[56px] h-[18px] flex text-center leading-[16px] rounded-[4px] border border-solid border-[#0093e6] box-content"
                key={index}
              >
                <span className="w-[22px] h-[18px] text-white text-[12px] ml-[-1px] rounded-[4px_0px_8px_4px] bg-[#0093e6]">
                  运
                </span>
                <span className="text-[#0093e6] mx-[5px]">包邮</span>
              </div>
            ) : item.couponType === 'product' ? (
              // 商品券
              <div
                className="mr-[6px] min-w-[88px] h-[18px] flex text-center leading-[16px] rounded-[4px] border border-solid border-[#e84c4c] box-content"
                key={index}
              >
                <span className="w-[22px] h-[18px] text-white text-[12px] ml-[-1px] rounded-[4px_0px_8px_4px] bg-[#e84c4c]">
                  商
                </span>
                {item.isUseConfig ? (
                  <span className="text-[#e84c4c] whitespace-nowrap mx-[5px]">
                    满{item.couponThresholdMoney || item.minOrderMoney || 0}-{item.couponAmount}
                  </span>
                ) : (
                  <span className="text-[#e84c4c] whitespace-nowrap mx-[5px]">最高减{item.couponAmount}</span>
                )}
              </div>
            ) : item.couponType === 'freight' ? (
              // 运费券
              <div
                className="mr-[6px] min-w-[88px] h-[18px] flex text-center leading-[16px] rounded-[4px] border border-solid border-[#0093e6] box-content"
                key={index}
              >
                <span className="w-[22px] h-[18px] text-white text-[12px] ml-[-1px] rounded-[4px_0px_8px_4px] bg-[#0093e6]">
                  运
                </span>
                <span className="text-[#0093e6] whitespace-nowrap font-normal mx-[5px]">
                  {item.couponAmount}元运费券
                </span>
              </div>
            ) : item.couponType === 'discount' ? (
              // 折扣券
              <div
                className="mr-[6px] min-w-[88px] h-[18px] flex text-center leading-[16px] rounded-[4px] border border-solid border-[#e84c4c] box-content"
                key={index}
              >
                <span className="w-[36px] h-[18px] text-white text-[12px] rounded-[4px_0px_8px_4px] bg-[#e84c4c]">
                  商
                </span>
                <span className="text-[#e84c4c] whitespace-nowrap mx-[5px]">
                  再享{Math.round(item.couponDiscount * 100) / 1000}折
                </span>
              </div>
            ) : (
              <></>
            )
          )}
        </>
      );
    }
    return <></>;
  };

  const [open, setOpen] = useState(false);
  const handleOpen = () => {
    setOpen(true);
  };

  return (
    <>
      <section
        className="px-4 py-3 flex items-center justify-between shadow-[inset_0_-1px_rgba(236,236,236,0.5)]"
        onClick={handleOpen}
      >
        <h2 className="text-[14px]">优惠券</h2>
        <div className="flex items-center w-[180px] text-[12px]">
          <CouponList />
        </div>
        <ChevronRight className="w-4 h-4 shrink-0 text-muted-foreground" />
      </section>
      <CouponListPopup data={data} open={open} onClose={() => setOpen(false)} />
    </>
  );
}
